/* tslint:disable */
// @ts-nocheck

/**
 * BreedLogicAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from './base';

/**
 *
 * @export
 * @interface AcceptEULARequest
 */
export interface AcceptEULARequest {
  /**
   *
   * @type {number}
   * @memberof AcceptEULARequest
   */
  userId?: number;
}
/**
 *
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  addressEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  unitNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  postCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddressDto
   */
  isAddressValid?: boolean;
}
/**
 *
 * @export
 * @interface CompleteWelcomeRequest
 */
export interface CompleteWelcomeRequest {
  /**
   *
   * @type {number}
   * @memberof CompleteWelcomeRequest
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof CompleteWelcomeRequest
   */
  preferredName: string;
}
/**
 *
 * @export
 * @interface ContactDetailsDto
 */
export interface ContactDetailsDto {
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  contactDetailsEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  mobileNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  faxNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof ContactDetailsDto
   */
  additionalEmail?: string | null;
}
/**
 *
 * @export
 * @interface CreateUserProfileRequest
 */
export interface CreateUserProfileRequest {
  /**
   *
   * @type {number}
   * @memberof CreateUserProfileRequest
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreateUserProfileRequest
   */
  isEulaAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  displayName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  preferredName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  surveyResponseData?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  unitNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  streetAddress: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  country: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  postCode: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CreateUserProfileRequest
   */
  isAddressValid?: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  faxNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  mobileNumber: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreateUserProfileRequest
   */
  additionalEmail?: string | null;
}
/**
 *
 * @export
 * @interface Pagination
 */
export interface Pagination {
  /**
   *
   * @type {number}
   * @memberof Pagination
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof Pagination
   */
  pageSize: number;
}
/**
 *
 * @export
 * @interface RefreshToken
 */
export interface RefreshToken {
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  refreshTokenId?: string;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  token: string;
  /**
   *
   * @type {number}
   * @memberof RefreshToken
   */
  userId: number;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  userEntityId: string;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  userExternalId: string;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  expiresAt: string;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  revokedAt?: string | null;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  revokedReason?: string | null;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  deviceInfo?: string | null;
  /**
   *
   * @type {string}
   * @memberof RefreshToken
   */
  ipAddress?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RefreshToken
   */
  isActive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RefreshToken
   */
  isExpired?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RefreshToken
   */
  isRevoked?: boolean;
  /**
   *
   * @type {User}
   * @memberof RefreshToken
   */
  user?: User;
}
/**
 *
 * @export
 * @interface SubmitSurveyRequest
 */
export interface SubmitSurveyRequest {
  /**
   *
   * @type {number}
   * @memberof SubmitSurveyRequest
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof SubmitSurveyRequest
   */
  surveyResponseData?: string | null;
}
/**
 *
 * @export
 * @interface SurveyResponse
 */
export interface SurveyResponse {
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof SurveyResponse
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof SurveyResponse
   */
  surveyResponseId?: number;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  surveyResponseEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof SurveyResponse
   */
  userProfileId?: number;
  /**
   *
   * @type {string}
   * @memberof SurveyResponse
   */
  surveyResponseData?: string | null;
  /**
   *
   * @type {UserProfile}
   * @memberof SurveyResponse
   */
  userProfile?: UserProfile;
}
/**
 *
 * @export
 * @interface SurveyResponseDto
 */
export interface SurveyResponseDto {
  /**
   *
   * @type {string}
   * @memberof SurveyResponseDto
   */
  surveyResponseEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof SurveyResponseDto
   */
  surveyResponseData?: string | null;
}
/**
 *
 * @export
 * @interface UpdateUserProfileNotificationRequest
 */
export interface UpdateUserProfileNotificationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateUserProfileNotificationRequest
   */
  userProfileId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpdateUserProfileNotificationRequest
   */
  isReceiveNotifications?: boolean;
}
/**
 *
 * @export
 * @interface UpdateUserProfileRequest
 */
export interface UpdateUserProfileRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateUserProfileRequest
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  userProfileEntityId?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateUserProfileRequest
   */
  isEulaAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  preferredName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  communicationPreferences?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  dateOfBirth: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  surveyResponseData?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  unitNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  streetAddress: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  country: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  postCode: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateUserProfileRequest
   */
  isAddressValid?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  phoneNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  faxNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  mobileNumber: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof UpdateUserProfileRequest
   */
  additionalEmail?: string | null;
}
/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {string}
   * @memberof User
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof User
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof User
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof User
   */
  userEntityId: string;
  /**
   *
   * @type {string}
   * @memberof User
   */
  externalIdentityId: string;
  /**
   *
   * @type {UserProfile}
   * @memberof User
   */
  userProfile?: UserProfile;
  /**
   *
   * @type {Array<RefreshToken>}
   * @memberof User
   */
  refreshTokens?: Array<RefreshToken> | null;
}
/**
 *
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof UserProfile
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof UserProfile
   */
  userProfileId?: number;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  userProfileEntityId: string;
  /**
   *
   * @type {number}
   * @memberof UserProfile
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UserProfile
   */
  isEulaAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  eulaAcceptedDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  preferredName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  communicationPreferences?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UserProfile
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  dateOfBirth: string;
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  displayName?: string | null;
  /**
   *
   * @type {User}
   * @memberof UserProfile
   */
  user?: User;
  /**
   *
   * @type {SurveyResponse}
   * @memberof UserProfile
   */
  surveyResponse?: SurveyResponse;
}
/**
 *
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  userProfileEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof UserProfileDto
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UserProfileDto
   */
  isEulaAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  eulaAcceptedDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  preferredName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  communicationPreferences?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UserProfileDto
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  displayName?: string | null;
  /**
   *
   * @type {ContactDetailsDto}
   * @memberof UserProfileDto
   */
  contactDetails?: ContactDetailsDto;
  /**
   *
   * @type {AddressDto}
   * @memberof UserProfileDto
   */
  address?: AddressDto;
  /**
   *
   * @type {SurveyResponseDto}
   * @memberof UserProfileDto
   */
  surveyResponse?: SurveyResponseDto;
}
/**
 *
 * @export
 * @interface UserSignUpRequest
 */
export interface UserSignUpRequest {
  /**
   *
   * @type {string}
   * @memberof UserSignUpRequest
   */
  externalIdentityId: string | null;
  /**
   *
   * @type {string}
   * @memberof UserSignUpRequest
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserSignUpRequest
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserSignUpRequest
   */
  email?: string | null;
}

/**
 * AccessApi - axios parameter creator
 * @export
 */
export const AccessApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAccessGetAccessTokenGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Access/GetAccessToken`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBootstrapPost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/bootstrap`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AccessApi - functional programming interface
 * @export
 */
export const AccessApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AccessApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAccessGetAccessTokenGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAccessGetAccessTokenGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessApi.apiAccessGetAccessTokenGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiBootstrapPost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiBootstrapPost(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AccessApi.apiBootstrapPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AccessApi - factory interface
 * @export
 */
export const AccessApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AccessApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAccessGetAccessTokenGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiAccessGetAccessTokenGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiBootstrapPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .apiBootstrapPost(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AccessApi - object-oriented interface
 * @export
 * @class AccessApi
 * @extends {BaseAPI}
 */
export class AccessApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessApi
   */
  public apiAccessGetAccessTokenGet(options?: RawAxiosRequestConfig) {
    return AccessApiFp(this.configuration)
      .apiAccessGetAccessTokenGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AccessApi
   */
  public apiBootstrapPost(options?: RawAxiosRequestConfig) {
    return AccessApiFp(this.configuration)
      .apiBootstrapPost(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MigrationApi - axios parameter creator
 * @export
 */
export const MigrationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMigrationEncryptRefreshTokensPost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Migration/encrypt-refresh-tokens`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MigrationApi - functional programming interface
 * @export
 */
export const MigrationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MigrationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMigrationEncryptRefreshTokensPost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMigrationEncryptRefreshTokensPost(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'MigrationApi.apiMigrationEncryptRefreshTokensPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MigrationApi - factory interface
 * @export
 */
export const MigrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MigrationApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMigrationEncryptRefreshTokensPost(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiMigrationEncryptRefreshTokensPost(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MigrationApi - object-oriented interface
 * @export
 * @class MigrationApi
 * @extends {BaseAPI}
 */
export class MigrationApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MigrationApi
   */
  public apiMigrationEncryptRefreshTokensPost(options?: RawAxiosRequestConfig) {
    return MigrationApiFp(this.configuration)
      .apiMigrationEncryptRefreshTokensPost(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UserSignUpRequest} [userSignUpRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserPost: async (
      userSignUpRequest?: UserSignUpRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/User`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userSignUpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UserSignUpRequest} [userSignUpRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserPost(
      userSignUpRequest?: UserSignUpRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(
        userSignUpRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserApi.apiUserPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserApiFp(configuration);
  return {
    /**
     *
     * @param {UserSignUpRequest} [userSignUpRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserPost(
      userSignUpRequest?: UserSignUpRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<User> {
      return localVarFp
        .apiUserPost(userSignUpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   *
   * @param {UserSignUpRequest} [userSignUpRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public apiUserPost(
    userSignUpRequest?: UserSignUpRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .apiUserPost(userSignUpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AcceptEULARequest} [acceptEULARequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileAcceptEulaPatch: async (
      acceptEULARequest?: AcceptEULARequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/AcceptEula`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        acceptEULARequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CompleteWelcomeRequest} [completeWelcomeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileCompleteWelcomePatch: async (
      completeWelcomeRequest?: CompleteWelcomeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/CompleteWelcome`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        completeWelcomeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGet: async (
      userId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Pagination} [pagination]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilePost: async (
      pagination?: Pagination,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/GetUserProfile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pagination,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByEntityIdsPost: async (
      requestBody?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/GetUserProfilesByEntityIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByUserEntityIdsPost: async (
      requestBody?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/GetUserProfilesByUserEntityIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByUserIdsPost: async (
      requestBody?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/GetUserProfilesByUserIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateUserProfileRequest} [updateUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfilePatch: async (
      updateUserProfileRequest?: UpdateUserProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserProfileRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateUserProfileRequest} [createUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfilePost: async (
      createUserProfileRequest?: CreateUserProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createUserProfileRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SubmitSurveyRequest} [submitSurveyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileSubmitSurveyPatch: async (
      submitSurveyRequest?: SubmitSurveyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/SubmitSurvey`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        submitSurveyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateUserProfileNotificationRequest} [updateUserProfileNotificationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileUpdateUserProfileNotificationPatch: async (
      updateUserProfileNotificationRequest?: UpdateUserProfileNotificationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserProfile/UpdateUserProfileNotification`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      // authentication ABRI-AUTH-CLIENT-ID required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'ABRI-AUTH-CLIENT-ID',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserProfileNotificationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserProfileApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AcceptEULARequest} [acceptEULARequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileAcceptEulaPatch(
      acceptEULARequest?: AcceptEULARequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileAcceptEulaPatch(
          acceptEULARequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfileAcceptEulaPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CompleteWelcomeRequest} [completeWelcomeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileCompleteWelcomePatch(
      completeWelcomeRequest?: CompleteWelcomeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileCompleteWelcomePatch(
          completeWelcomeRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'UserProfileApi.apiUserProfileCompleteWelcomePatch'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileGet(
      userId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileGet(userId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfileGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Pagination} [pagination]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileGetUserProfilePost(
      pagination?: Pagination,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileGetUserProfilePost(
          pagination,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfileGetUserProfilePost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileGetUserProfilesByEntityIdsPost(
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileGetUserProfilesByEntityIdsPost(
          requestBody,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'UserProfileApi.apiUserProfileGetUserProfilesByEntityIdsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileGetUserProfilesByUserEntityIdsPost(
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileGetUserProfilesByUserEntityIdsPost(
          requestBody,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'UserProfileApi.apiUserProfileGetUserProfilesByUserEntityIdsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileGetUserProfilesByUserIdsPost(
      requestBody?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileGetUserProfilesByUserIdsPost(
          requestBody,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'UserProfileApi.apiUserProfileGetUserProfilesByUserIdsPost'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {UpdateUserProfileRequest} [updateUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfilePatch(
      updateUserProfileRequest?: UpdateUserProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfilePatch(
          updateUserProfileRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfilePatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreateUserProfileRequest} [createUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfilePost(
      createUserProfileRequest?: CreateUserProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfilePost(
          createUserProfileRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfilePost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SubmitSurveyRequest} [submitSurveyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileSubmitSurveyPatch(
      submitSurveyRequest?: SubmitSurveyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileSubmitSurveyPatch(
          submitSurveyRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UserProfileApi.apiUserProfileSubmitSurveyPatch']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {UpdateUserProfileNotificationRequest} [updateUserProfileNotificationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserProfileUpdateUserProfileNotificationPatch(
      updateUserProfileNotificationRequest?: UpdateUserProfileNotificationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserProfileUpdateUserProfileNotificationPatch(
          updateUserProfileNotificationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'UserProfileApi.apiUserProfileUpdateUserProfileNotificationPatch'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserProfileApiFp(configuration);
  return {
    /**
     *
     * @param {AcceptEULARequest} [acceptEULARequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileAcceptEulaPatch(
      acceptEULARequest?: AcceptEULARequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserProfileAcceptEulaPatch(acceptEULARequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CompleteWelcomeRequest} [completeWelcomeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileCompleteWelcomePatch(
      completeWelcomeRequest?: CompleteWelcomeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserProfileCompleteWelcomePatch(completeWelcomeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGet(
      userId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserProfileDto> {
      return localVarFp
        .apiUserProfileGet(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Pagination} [pagination]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilePost(
      pagination?: Pagination,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiUserProfileGetUserProfilePost(pagination, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByEntityIdsPost(
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiUserProfileGetUserProfilesByEntityIdsPost(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByUserEntityIdsPost(
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiUserProfileGetUserProfilesByUserEntityIdsPost(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileGetUserProfilesByUserIdsPost(
      requestBody?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiUserProfileGetUserProfilesByUserIdsPost(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateUserProfileRequest} [updateUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfilePatch(
      updateUserProfileRequest?: UpdateUserProfileRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserProfileDto> {
      return localVarFp
        .apiUserProfilePatch(updateUserProfileRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreateUserProfileRequest} [createUserProfileRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfilePost(
      createUserProfileRequest?: CreateUserProfileRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserProfileDto> {
      return localVarFp
        .apiUserProfilePost(createUserProfileRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SubmitSurveyRequest} [submitSurveyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileSubmitSurveyPatch(
      submitSurveyRequest?: SubmitSurveyRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserProfileSubmitSurveyPatch(submitSurveyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateUserProfileNotificationRequest} [updateUserProfileNotificationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserProfileUpdateUserProfileNotificationPatch(
      updateUserProfileNotificationRequest?: UpdateUserProfileNotificationRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserProfileUpdateUserProfileNotificationPatch(
          updateUserProfileNotificationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI {
  /**
   *
   * @param {AcceptEULARequest} [acceptEULARequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileAcceptEulaPatch(
    acceptEULARequest?: AcceptEULARequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileAcceptEulaPatch(acceptEULARequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CompleteWelcomeRequest} [completeWelcomeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileCompleteWelcomePatch(
    completeWelcomeRequest?: CompleteWelcomeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileCompleteWelcomePatch(completeWelcomeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileGet(userId?: number, options?: RawAxiosRequestConfig) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Pagination} [pagination]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileGetUserProfilePost(
    pagination?: Pagination,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileGetUserProfilePost(pagination, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<string>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileGetUserProfilesByEntityIdsPost(
    requestBody?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileGetUserProfilesByEntityIdsPost(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<string>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileGetUserProfilesByUserEntityIdsPost(
    requestBody?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileGetUserProfilesByUserEntityIdsPost(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<number>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileGetUserProfilesByUserIdsPost(
    requestBody?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileGetUserProfilesByUserIdsPost(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateUserProfileRequest} [updateUserProfileRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfilePatch(
    updateUserProfileRequest?: UpdateUserProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfilePatch(updateUserProfileRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreateUserProfileRequest} [createUserProfileRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfilePost(
    createUserProfileRequest?: CreateUserProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfilePost(createUserProfileRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SubmitSurveyRequest} [submitSurveyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileSubmitSurveyPatch(
    submitSurveyRequest?: SubmitSurveyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileSubmitSurveyPatch(submitSurveyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateUserProfileNotificationRequest} [updateUserProfileNotificationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiUserProfileUpdateUserProfileNotificationPatch(
    updateUserProfileNotificationRequest?: UpdateUserProfileNotificationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserProfileApiFp(this.configuration)
      .apiUserProfileUpdateUserProfileNotificationPatch(
        updateUserProfileNotificationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
